<template>
    <rkm-overlay>
        <rkm-layout-body
            title="Ficha de vacinação"
        >
            <template
                v-slot:actions
            >
                <rkm-button
                    color="danger"
                    @click="handleExit"
                >
                    Sair
                </rkm-button>
            </template>
        </rkm-layout-body>

        <rkm-layout-content>
            <Edit
                :id="id"
            />
        </rkm-layout-content>
    </rkm-overlay>
</template>

<script>
import Edit from  '@/components/atencao-basica/ficha-vacinacao/Edit'

export default {
    components: {
        Edit
    },
    methods: {
        handleExit() {
            this.$router.push({ name: 'atencao-basica-ficha-vacinacao' })
        },
    },
    props: {
        id: { type: Number, default: null }
    }
}
</script>